(function () {
    'use strict';

    angular.module('swif.framework')
    .service('swifFullCalendarService', swifFullCalendarService);

    /**
    * @ngdoc service
    * @name swif.framework.swifFullCalendarService
    * @requires swif.framework.swifMomentUtility
    * @requires swif.framework.settingsService
    * @requires swif.framework.swifModal
    * @description provide api to handle fullcalendar stuff
    **/
    function swifFullCalendarService($location, swifMomentUtility, settingsService, gettextCatalog, swifModal, uiCalendarConfig, amMoment) {
        'ngInject';
        var i18n = gettextCatalog;
        var modal = swifModal;
        var service = {};

        service.updateLocation = function (view) {
            var newStart = moment.utc(view.intervalStart);
            $location.search('calendar:start', newStart.format('YYYY-MM-DD'));
            $location.search('calendar:type', view.type || null);
        };

        service.parseLocation = function (fullcalendar) {
            var start = $location.search()['calendar:start'];
            var type = $location.search()['calendar:type'];
            if (fullcalendar && start) {
                fullcalendar.defaultDate = moment.utc(start);
            }
            if (fullcalendar && type) {
                fullcalendar.defaultView = type;
            }
        };

        service.addSpecialDays = function (eventSource) {
            _.forEach(swifMomentUtility.specialdays_events, function (spd) {
                // The planning will display specialdays period until the end of the last day
                // instead of considering it ending at midnight and skipping the last day
                if (spd.date_end) {
                    var endDate = moment(spd.date_end).add(1,"days").format("YYYY-MM-DD");
                } else {
                    var endDate = moment(spd.date_start);
                }
                eventSource.push({
                    id: 'specialday-' + spd.date_start,
                    title: spd.name,
                    timezone: 'UTC',
                    start: moment(spd.date_start, 'YYYY-MM-DD'),
                    end: endDate,
                    allDay: true,
                    color: '#888',
                    editable: false
                });
            });
        };

        service.getFullcalendar = function () {
            var lang = window.localStorage.getItem('language') || 'fr';

            //get settings from BE (default.json)
            var settings = settingsService.app.fullcalendar;
            //get settings from local storage
            var l_settings = settingsService.get('fullcalendar');

            if (l_settings) {
                l_settings.lang = lang;

                if (l_settings.version !== settings.version) {
                    settingsService.set('fullcalendar', settings);
                } else {
                    var businessHours = angular.copy(settings.businessHours)
                    var defaultDate = angular.copy(settings.defaultDate)
                    settings = l_settings;
                    settings.businessHours = businessHours;
                    settings.defaultDate = defaultDate;
                }
            } else {
                settings.lang = lang;
                settingsService.set('fullcalendar', settings);
            }

            // Force moment locale cause fullCalendar set moment to default 'en'
            amMoment.changeLocale(lang);

            var copy = angular.copy(settings);
            var date = moment().format('YYYY-MM-DD');
            copy.customButtons = {
                goToDateButton: {
                    text: i18n.getString('Go to date'),
                    click: function () {
                        var config = {
                            title: 'Go to date',
                            model: date,
                            size: 'sm',
                            templateUrl: 'partials/framework/fullcalendar_gotodate.html',
                            action: {
                                title: 'Go to this date'
                            }
                        };
                        //display modal to select a date
                        var modalinstance = modal.open(config);
                        modalinstance.result.then(function () {
                            uiCalendarConfig.calendars.planning.fullCalendar('gotoDate', config.model);
                        });
                    }
                }
            };
            return copy;
        };

        service.updateFullCalendar = function (fullcalendar) {
            //settings we don't want to save in localStorage
            var blackParametersList = ['defaultDate'];
            if (!fullcalendar) {
                return;
            }
            var l_settings = settingsService.get('fullcalendar');
            _.forOwn(fullcalendar, function (value, key) {
                if (!_.contains(blackParametersList, key)){
                    if (l_settings[key] !== undefined) {
                        l_settings[key] = value;
                    }
                }
            });
        };
        return service;
    }

})();
